import { useCallback } from "react";
import { useCreateClassMutation } from "@api/class.api";
import { ClassForm, ClassSchema } from "./ClassForm";

export const CreateClassModal = ({
    parentClassId,
    onHide,
    onCreated,
}: {
    onHide: () => void;
    parentClassId: string | null;
    onCreated?: () => void;
}) => {
    const createMutation = useCreateClassMutation();

    const onSubmit = useCallback(
        async (classData: ClassSchema) => {
            const created = await createMutation.mutateAsync({
                label: classData.name,
                parentClassId: classData.parentClassId,
            });
            onCreated?.();
            return created;
        },
        [createMutation, onCreated],
    );

    return (
        <ClassForm
            onHide={onHide}
            onSubmitClass={onSubmit}
            isPending={createMutation.isPending}
            parentClassId={parentClassId}
        />
    );
};
